import connection from "@/api/connection";

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const productsByLote = async ({ commit }, lote) => {
  commit("setProductsByLoteIsLoading", true);
  await connection
    .get(`/products/lote/${lote}`)
    .then((res) => {
      commit("setProductsByLote", res.data.data);
      commit("setProductsByLoteIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductsByLoteIsLoading", false);
    });
};

export const getProductListByTypeProductClient = async (
  { commit },
  options
) => {
  let url = `/products/selectable/typeproduct/${options.typeproductId}/client/${options.clientId}`;

  await connection
    .get(url)
    .then((res) => {
      commit("setProductListByTypeProductClientSelectable", res.data.data);
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const getProductListByClient = async ({ commit }, clientId) => {
  commit("setProductListByClientIsLoading", true);

  let url = `/products/selectable/client/${clientId}`;

  await connection
    .get(url)
    .then((res) => {
      commit("setProductListByClientSelectable", res.data.data);
      commit("setProductListByClientIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductListByClientIsLoading", false);
    });
};

export const getProducts = async ({ commit }) => {
  let url = `/products/selectable`;

  await connection
    .get(url)
    .then((res) => {
      const products = res.data.data;
      commit("setProductsSelectable", products);
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const loadProducts = async ({ commit }, query = null) => {
  let page = 1;
  let search = "";
  let perPage = 25;
  if (query !== null) {
    page = query?.page || 1;
    search = query?.search || "";
    perPage = query?.perPage || 25;
  }

  commit("setProductIsLoading", true);
  let url = `/products`;
  if (search === "") {
    url = `${url}?page=${page}&perPage=${perPage}`;
  } else {
    url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
  }

  await connection
    .get(url)
    .then((res) => {
      const products = res.data.data;
      commit("setProducts", products);
      const pagination = {
        totalItems: res.data.totalItems, // total number of elements or items
        // per_page: res.data.per_page, // items per page
        currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
        totalPages: res.data.totalPages, // total pages in record

        perPage: res.data.perPage,
      };
      res.data.pagination = pagination;
      commit("setProductsPaginated", res.data);
      commit("setProductIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductIsLoading", false);
    });
};

export const productById = async ({ commit }, id) => {
  commit("setProductIsLoading", true);
  await connection
    .get(`/products/${id}`)
    .then((res) => {
      commit("setProductDetail", res.data.data);
      commit("setProductIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductIsLoading", false);
    });
};

export const storeProduct = async ({ commit }, product) => {
  commit("setProductIsCreating", true);
  await connection
    .post(`/products/create`, product)
    .then((res) => {
      commit("saveNewProducts", res.data);
      commit("setProductIsCreating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductIsCreating", false);
    });
};

export const updateProduct = async ({ commit }, product) => {
  commit("setProductIsUpdating", true);
  await connection
    .put(`/products/${product.id}/update`, product)
    .then((res) => {
      commit("saveUpdatedProduct", res.data);
      commit("setProductIsUpdating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductIsUpdating", false);
    });
};

export const deleteProduct = async ({ commit }, product) => {
  commit("setProductIsDeleting", true);
  await connection
    .delete(`/products/${product.id}/delete`)
    .then((res) => {
      commit("setDeleteProduct", res.data);
      commit("setProductIsDeleting", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductIsDeleting", false);
    });
};

export const findProductByNamePresentationClient = async (
  { commit },
  product
) => {
  commit("setProductByNamePresentationClientIsCreating", true);
  await connection
    .post(`/products/findByNamePresentationClient`, product)
    .then((res) => {
      commit("saveProductByNamePresentationClient", res.data.data);
      commit("setProductByNamePresentationClientIsCreating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setProductByNamePresentationClientIsCreating", false);
    });
};

export const findProductByNamePresentationClientTotalAmountUnit = async (
  { commit },
  product
) => {
  commit("setProductByNamePresentationClientTotalAmountUnitIsCreating", true);
  await connection
    .post(`/products/findByNamePresentationClientTotalAmountUnit`, product)
    .then((res) => {
      commit(
        "saveProductByNamePresentationClientTotalAmountUnit",
        res.data.data
      );
      commit(
        "setProductByNamePresentationClientTotalAmountUnitIsCreating",
        false
      );
    })
    .catch((err) => {
      console.log("error", err);
      commit(
        "setProductByNamePresentationClientTotalAmountUnitIsCreating",
        false
      );
    });
};
